import React, {lazy, Suspense} from "react";
import useIsMobile from "@Hooks/selector/useIsMobile";

const IconMTicketQr = lazy(() => import(
    /* webpackChunkName: "MTicket" */
    "@Icons/IconMTicketQr"
    ));

function MTicketPopoverTrigger() {
    const isMobile = useIsMobile()
    const styleAttribute = (!isMobile) ? {transform: 'rotate(-10deg)'} : null;

    return (
        <span className={`gb--row${isMobile ? ' gb--badge gb--badge-left gb--badge-green' : ''}`}>
            <Suspense fallback={null}>
                <IconMTicketQr style={styleAttribute}/>
            </Suspense>
            <span className="gb--ticket_label">
                <span>M-TICKET</span>
                <span className="hidden-xs">
                    <i className="fa fa-leaf gb--emphasize-warning" aria-hidden="true"/>
                    {' '}
                    ECO
                </span>
                <span className="hidden-xs">FRIENDLY</span>
            </span>
        </span>
    )
}

export default MTicketPopoverTrigger